import React from 'react';

import { useGraphQLQuery } from '@betterment/js-runtime';
import { Card, Heading, Separator } from '@betterment/samba-react';
import { CardLoader, ErrorBoundary } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { PurposeArticlesCardDocument } from './graphql/purposeArticlesCard.generated';

import { Article } from '../../../Shared/components-v2/article/Article';

const MAX_ARTICLES_TO_DISPLAY = 4;

const ArticlesCardView: React.FC = () => {
  const purposeId = useRequiredParam('purposeId');
  const { data } = useGraphQLQuery(PurposeArticlesCardDocument, { variables: { id: purposeId }, throwOnError: true });

  if (!data) return <CardLoader />;
  const { articles } = data.purpose.envelope;
  if (!articles.length) return null;

  const articlesToDisplay = articles.slice(0, MAX_ARTICLES_TO_DISPLAY);

  return (
    <Card css={{ padding: 'space.300', display: 'grid', gap: 'space.300' }}>
      <Card.Header>
        <Heading as="h2" variant="title200">
          Learn more
        </Heading>
      </Card.Header>
      <Separator />
      <Card.Content
        css={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(30rem, 1fr))',
          gap: { base: 'space.200', md: 'space.300' },
        }}
      >
        {articlesToDisplay.map(article => (
          <Article key={article.id} {...article} />
        ))}
      </Card.Content>
    </Card>
  );
};

export const ArticlesCard: React.FC = () => (
  <ErrorBoundary fallbackType="none">
    <ArticlesCardView />
  </ErrorBoundary>
);
